/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://kazupon.github.io/vue-i18n/
 */

import Vue from "vue"
import VueI18n from "vue-i18n"

import de from "@/i18n/de.json"
import en from "@/i18n/en.json"
import fr from "@/i18n/fr.json"
import it from "@/i18n/it.json"
import { reactive } from "@vue/composition-api"
import { getLanguage } from "../app/reactive/language.state"
import { TranslationLocale } from "@/app/models/translation-locale"

Vue.use(VueI18n)

const supportedLanguages = [
  TranslationLocale.German,
  TranslationLocale.English,
  TranslationLocale.French,
  TranslationLocale.Italian,
]

const localeState = getLanguage(supportedLanguages)

// Add more languages here
const messages = {
  de,
  en,
  fr,
  it,
}

export const i18n = new VueI18n({
  locale: localeState,
  fallbackLocale: "de",
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  messages: messages,
})

export const locales = reactive([
  { code: TranslationLocale.German, short: "DE", lang: i18n.t("locale.de") },
  { code: TranslationLocale.English, short: "EN", lang: i18n.t("locale.en") },
  { code: TranslationLocale.French, short: "FR", lang: i18n.t("locale.fr") },
  { code: TranslationLocale.Italian, short: "IT", lang: i18n.t("locale.it") },
])
